import { useOTPs } from '../../new/pages/collections/hooks';
import auth from '../../components/auth';
import { keys } from '../../new/helpers/general';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';

export const tabs = {
  subscriptions: 'Subscriptions',
  otps: 'One-time Purchases',
};

export type TabHash = keyof typeof tabs;

type AnalyticsTabs = Array<[hash: TabHash, name: string]>;

export const useInfluencerAnalyticsTabs = (): AnalyticsTabs => {
  const influencerId = useInfluencerId();
  const otps = useOTPs(influencerId);
  const isOtpVisible =
    (otps.type === 'fetched' && otps.value.length > 0) ||
    auth.isAdministrator();

  const tabsParsed = keys(tabs).flatMap((hash) =>
    hash !== 'otps' || isOtpVisible
      ? ([[hash, tabs[hash]]] as AnalyticsTabs)
      : [],
  );

  return tabsParsed;
};
